module.exports = __webpack_public_path__ + "static/media/pageBg.d76b05ad.png";